const commonWorksheetMassHeaders = {
    'text':             'Name',
    'contacts':         'Contacts',
    'working':          'Work with person',
    'status':           'Status',
    'sourceforsys':     'Source of appearance in system',
    'sourceforprj':     'Source of appearance in project',
    'stageresult':      'Stage result',
    'prevStageResults': 'Previous stage result',
    'workplace':        'Employer',
    'position':         'Position',
    'documents':        'Documents',
    'partsInProject':   'Participated in projects',
    'comment':          'Notes',
    'education':        'Education',
};

export default {
    worksheet: {
        create: 'Schedule an event',
        scheduleDocument: 'Schedule enter',
        createDocument: 'Enter document',
        pickDocuments: 'Pick document from DB',
        changePersonState: 'Change state',
        only_participants_can_create: 'Only project participants can create events',
        only_participants_can_change_state: 'Only project participants can change state',
        headers: {
            'settingsTitle':    'Project SearchWorksheet settings',
            'title':            'Project SearchWorksheet',
            'text':             'Name',
            'status':           'Status',
            'additionalStatus': 'Add. state',
            'contacts':         'Contacts',
            'working':          'Work with person',
            'partsInProject':   'Participated in projects',
            'sourceForProject': 'Source of appearance in project',
            'sourceForSys':     'Source of appearance in system',
            'workplace':        'Employer',
            'position':         'Position',
            'documents':        'Documents',
            'comment':          'Notes',
            'notes':            'Note',
            'education':        'Education',
            'hrnetnotify':      'HR-network notifications',
            'sourcecomment':    'Note for source of appearance in project'
        },

        title: 'Project SearchWorksheet',
        unsupported: 'The project currently has a “Request” status, thus it does not have a summary.<br> In order to create a summary for the project, its status needs to be changed to “In progress” in the Experium desktop application.',
        messages: {
            needEvents: 'You need to enter this documents to change person state:',
            personStateChanged: 'Successfully changed person state',
        },
    },
    worksheetMass: {
        mass_license: 'You do not have the license "Mass recruitment"',
        create: 'Schedule an event',
        changePersonState: 'Change state',
        only_participants_can_create: 'Only project participants can create events',
        headers: {
            'settingsTitle': 'Project SearchWorksheet MAP settings',
            ...commonWorksheetMassHeaders,
        },
        excludedHeaders: {
            ...commonWorksheetMassHeaders,
            stageresult: 'Reason for exception'
        },
        title: 'Project SearchWorksheet',
        unsupported: 'The project currently has a “Request” status, thus it does not have a summary.<br> In order to create a summary for the project, its status needs to be changed to “In progress” in the Experium desktop application.',
        stages: 'Stages',
        changeStage: 'Change stage',
        excluded: 'Excluded',
        toolTips: {
            notParticipant: 'To view a project summary, you must be Responsible or Collaborator'
        },
        messages: {
            emptyEvents: 'There are no events for this stage',
        },
    },
};
